/**
 * @generated SignedSource<<60773055b135d376f7cc396a988f853b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "partnerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vppId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "vppId",
    "variableName": "vppId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vendorId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultParmValue",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logo",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "repFname",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "repLname",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "repEmail",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "repImg",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaTitle",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaText",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaButton",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaLabel",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaTitleSuspend",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaTextSuspend",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaTitleDecline",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaTextDecline",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaTitleLeft",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaTextLeft",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programType",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qualificationPeriod",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoPayout",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenuePeriod",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenueMin",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incentivePerc",
  "storageKey": null
},
v33 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "partnerId",
        "variableName": "partnerId"
      }
    ],
    "kind": "ObjectValue",
    "name": "condition"
  }
],
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partnerId",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vpprId",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resellerPId",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stage",
  "storageKey": null
},
v39 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "ASSET_ORDER_ASC"
  }
],
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetType",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetLink",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetTitle",
  "storageKey": null
},
v43 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "blockType": 0
    }
  }
],
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentBlockId",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vppContentBlockId",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "VendorPartnerProgramQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "VppT",
        "kind": "LinkedField",
        "name": "vppTByVppId",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByVendorId",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CpT",
            "kind": "LinkedField",
            "name": "cpTByCtaCpId",
            "plural": false,
            "selections": [
              (v26/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CpLineTsConnection",
                "kind": "LinkedField",
                "name": "cpLineTsByCpId",
                "plural": false,
                "selections": [
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CpLineT",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v33/*: any*/),
            "concreteType": "VppRtsConnection",
            "kind": "LinkedField",
            "name": "vppRTsByVppId",
            "plural": false,
            "selections": [
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VppRT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v34/*: any*/),
                  (v35/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountT",
                    "kind": "LinkedField",
                    "name": "accountTByPartnerId",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ResellerProgramTsConnection",
                        "kind": "LinkedField",
                        "name": "resellerProgramTsByResellerAccountId",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ResellerProgramT",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              (v36/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CpT",
                                "kind": "LinkedField",
                                "name": "cpTByCpId",
                                "plural": false,
                                "selections": [
                                  (v37/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v38/*: any*/),
                  (v6/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v39/*: any*/),
            "concreteType": "VppAssetTsConnection",
            "kind": "LinkedField",
            "name": "vppAssetTsByVppId",
            "plural": false,
            "selections": [
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VppAssetT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v38/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/),
                  (v42/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "vppAssetTsByVppId(orderBy:\"ASSET_ORDER_ASC\")"
          },
          {
            "alias": null,
            "args": (v43/*: any*/),
            "concreteType": "VppContentBlockTsConnection",
            "kind": "LinkedField",
            "name": "vppContentBlockTsByVppId",
            "plural": false,
            "selections": [
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VppContentBlockT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v38/*: any*/),
                  (v44/*: any*/),
                  (v45/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "vppContentBlockTsByVppId(condition:{\"blockType\":0})"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "VendorPartnerProgramQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "VppT",
        "kind": "LinkedField",
        "name": "vppTByVppId",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByVendorId",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v46/*: any*/)
            ],
            "storageKey": null
          },
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CpT",
            "kind": "LinkedField",
            "name": "cpTByCtaCpId",
            "plural": false,
            "selections": [
              (v26/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CpLineTsConnection",
                "kind": "LinkedField",
                "name": "cpLineTsByCpId",
                "plural": false,
                "selections": [
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CpLineT",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v46/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v46/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v33/*: any*/),
            "concreteType": "VppRtsConnection",
            "kind": "LinkedField",
            "name": "vppRTsByVppId",
            "plural": false,
            "selections": [
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VppRT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v34/*: any*/),
                  (v35/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountT",
                    "kind": "LinkedField",
                    "name": "accountTByPartnerId",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ResellerProgramTsConnection",
                        "kind": "LinkedField",
                        "name": "resellerProgramTsByResellerAccountId",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ResellerProgramT",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              (v36/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CpT",
                                "kind": "LinkedField",
                                "name": "cpTByCpId",
                                "plural": false,
                                "selections": [
                                  (v37/*: any*/),
                                  (v46/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v46/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v46/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v38/*: any*/),
                  (v6/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v46/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v39/*: any*/),
            "concreteType": "VppAssetTsConnection",
            "kind": "LinkedField",
            "name": "vppAssetTsByVppId",
            "plural": false,
            "selections": [
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VppAssetT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v38/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/),
                  (v42/*: any*/),
                  (v46/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "vppAssetTsByVppId(orderBy:\"ASSET_ORDER_ASC\")"
          },
          {
            "alias": null,
            "args": (v43/*: any*/),
            "concreteType": "VppContentBlockTsConnection",
            "kind": "LinkedField",
            "name": "vppContentBlockTsByVppId",
            "plural": false,
            "selections": [
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VppContentBlockT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v38/*: any*/),
                  (v44/*: any*/),
                  (v45/*: any*/),
                  (v46/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "vppContentBlockTsByVppId(condition:{\"blockType\":0})"
          },
          (v46/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5961d88d98c52bcc3407843c6b532a9a",
    "id": null,
    "metadata": {},
    "name": "VendorPartnerProgramQuery",
    "operationKind": "query",
    "text": "query VendorPartnerProgramQuery(\n  $vppId: UUID!\n  $partnerId: UUID!\n) {\n  vppTByVppId(vppId: $vppId) {\n    vendorId\n    programName\n    description\n    notes\n    visibility\n    defaultParmValue\n    formId\n    accountTByVendorId {\n      accountName\n      logo\n      nodeId\n    }\n    repFname\n    repLname\n    repEmail\n    repImg\n    ctaTitle\n    ctaText\n    ctaButton\n    ctaLabel\n    ctaTitleSuspend\n    ctaTextSuspend\n    ctaTitleDecline\n    ctaTextDecline\n    ctaTitleLeft\n    ctaTextLeft\n    cpTByCtaCpId {\n      programType\n      programName\n      description\n      qualificationPeriod\n      autoPayout\n      cpLineTsByCpId {\n        totalCount\n        nodes {\n          revenuePeriod\n          revenueMin\n          incentivePerc\n          nodeId\n        }\n      }\n      nodeId\n    }\n    vppRTsByVppId(condition: {partnerId: $partnerId}) {\n      totalCount\n      nodes {\n        partnerId\n        vpprId\n        accountTByPartnerId {\n          resellerProgramTsByResellerAccountId {\n            totalCount\n            nodes {\n              resellerPId\n              cpTByCpId {\n                accountId\n                nodeId\n              }\n              nodeId\n            }\n          }\n          nodeId\n        }\n        stage\n        notes\n        repFname\n        repLname\n        repEmail\n        repImg\n        nodeId\n      }\n    }\n    vppAssetTsByVppId(orderBy: ASSET_ORDER_ASC) {\n      totalCount\n      nodes {\n        stage\n        assetType\n        assetLink\n        assetTitle\n        nodeId\n      }\n    }\n    vppContentBlockTsByVppId(condition: {blockType: 0}) {\n      totalCount\n      nodes {\n        stage\n        parentBlockId\n        vppContentBlockId\n        nodeId\n      }\n    }\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "fd11c9a9608199aa001400923122118b";

module.exports = node;
